module.exports = __webpack_public_path__ + "img/img006.be7a994b.png";